var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitKeepLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 290,
    viewBox: "0 0 258 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.1 81.7V96.2C257.1 99.1 255.6 101.7 253.1 103.1L206.2 130.2L248.1 154.3C253.7 157.5 257.1 163.5 257.1 169.9V208.7C257.1 215.1 253.7 221.1 248.1 224.3L138 287.5C132.4 290.7 125.6 290.7 120 287.5L83.9 266.7C81.2 265.2 81.2 261.3 83.9 259.8L202.9 191.3C204.2 190.5 204.2 188.6 202.9 187.8L158.7 162.3C156.2 160.9 153.2 160.9 150.7 162.3L29.8 232C28 233.1 25.7 233.1 23.8 232L10.1 224.2C4.50002 221 1.00002 215 1.00002 208.6V192.7C1.00002 190.6 2.10002 188.6 4.00002 187.5L177.3 87.9C178.6 87.1 178.6 85.2 177.3 84.4L133 58.8C130.5 57.4 127.5 57.4 125 58.8L6.90002 126.7C4.20002 128.2 0.900024 126.3 0.900024 123.2V81.6C0.900024 75.2 4.30002 69.2 9.90002 66L120 2.80002C125.6 -0.399976 132.4 -0.399976 138 2.80002L247.9 66.2C253.7 69.3 257.1 75.3 257.1 81.7Z",
    fill: "#7524F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitKeepLogo);
export default __webpack_public_path__ + "static/media/bitKeepLogo.eb5e1a57.svg";
export { ForwardRef as ReactComponent };